<template>
  <div>
    <div class="row" v-for="(item, index) in list" :key="index">
      <div class="label">{{ item.label }}：</div>
      <div class="value">
        <!-- 全部 -->
        <div class="item val" :class="{ select: item.check }" @click="allCheck(index)">
          {{ $t("message.all") }}
        </div>
        <!-- 选项 -->
        <div class="item" v-for="(items, indexs) in item.options" :key="indexs">
          <div :class="{ disabled: item.disabled }">
            <div class="border"></div>
          </div>
          <div @click="clickCelect(index, indexs)" :class="{ select: items.check, itemDisabled: item.disabled }"
            class="val">
            {{ items.v }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getClientPageFilterCols();
  },
  methods: {
    getClientPageFilterCols() {
      this.$api.productManagementApi.getClientPageFilterCols().then((res) => {
        this.list = res.data;
      });
    },
    // 点击选择
    clickCelect(index, indexs) {
      this.list[index].options[indexs].check =
        !this.list[index].options[indexs].check;
      // 是否全选
      let flag = this.list[index].options.every((item) => !item.check);
      flag ? (this.list[index].check = true) : (this.list[index].check = false);
      this.$forceUpdate();
    },
    // 选择全部
    allCheck(index) {
      this.list[index].options.forEach((item) => {
        item.check = false;
      });
      this.list[index].check = true;
      this.$forceUpdate();
    },
    // 选择项 flag = true 重置 = false 取当前选择项
    option(flag) {
      let datas = {
      };
      if (!flag) {
        this.list.forEach((item) => {
          if (!item.check) {
            datas[item.field] = []
            item.options.forEach((items) => {
              if (items.check) {
                datas[item.field].push(items.k);
              }
            });
          }
        });
      } else {
        this.list.forEach((item) => {
          item.check = true;
          item.options.forEach((items) => {
            items.check = false;
          });
        });
      }

      return datas;
    },
  },
};
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  line-height: 32px;
  margin-bottom: 16px;
  position: relative;

  .label {
    width: 120px;
  }

  .value {
    flex: 10;
    display: flex;
    flex-wrap: wrap;

    .item {
      height: 32px;
      background: transparent;
      margin-right: 16px;
      text-align: center;
      cursor: pointer;
      position: relative;
    }

    .val {
      padding: 0 14px;
      border-radius: 4px;
    }

    .itemDisabled {
      cursor: not-allowed;
    }

    .select {
      background-color: #b4272d;
      color: #fff;
    }
  }
}

.disabled {
  position: absolute;
  top: 0;
  left: 0;
  height: 32px;
  width: 100%;
  cursor: not-allowed;

  .border {
    height: 2px;
    margin-top: 15px;
    width: 90%;
    background-color: #000;
    transform: rotate(20deg);
  }

}
</style>